import React from 'react';
import { MessageSquareIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { pageSeo } from '../data/seo';
import { shopJsonLd } from '../data/structuredData';
import { products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
import { TextButton } from '../components/TextButton';
import { FaqSection } from '../components/FaqSection';
import { TextCta } from '../components/TextCta';
import { smsMessages } from '../utils/sms';
const assurances = [{
  icon: MessageSquareIcon,
  title: 'Order over text',
  body: 'No cart, no checkout maze. Text us the system you want and a specialist confirms sizing, price and install date.'
}, {
  icon: CreditCardIcon,
  title: 'Financing available',
  body: 'Approval takes minutes. We can send you the application link in the same conversation.'
}, {
  icon: ShieldCheckIcon,
  title: 'Lifetime warranty',
  body: 'Every residential system carries a lifetime warranty and a 30-day money-back guarantee.'
}];
export function Shop() {
  return <main data-id="element-315" data-mp="3iil8j5z6satc">
      <Seo {...pageSeo.shop} jsonLd={shopJsonLd} data-id="element-316" data-mp="3iicydlug7jlu" />
      <section className="bg-canvas pb-14 pt-14 lg:pb-16 lg:pt-20" data-id="element-317" data-mp="3ih1wjrkkclxd">
        <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-318" data-mp="3namrtburv1sv">
          <p className="mb-4 text-xs uppercase tracking-[0.18em] text-aqua-600" data-id="element-319" data-mp="3rbyb6zn1yqsm">
            Shop systems
          </p>
          <h1 className="max-w-3xl font-display text-[38px] font-semibold leading-[1.03] tracking-tightest text-ink-950 sm:text-[52px]" data-id="element-320" data-mp="2umr06lk2802y">
            Four systems. One text away.
          </h1>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-ink-700" data-id="element-321" data-mp="33l2mibdw8bpl">
            Every system retrofits into your existing pool or spa. Not sure
            which one fits? Text us your gallonage and we&rsquo;ll size it for
            you.
          </p>
          <div className="mt-8" data-id="element-322" data-mp="nupvalbvy10j">
            <TextButton message={smsMessages.quote} size="lg" data-id="element-323" data-mp="nty89ywctblv">
              Text us
            </TextButton>
          </div>
        </div>
      </section>

      <section className="bg-canvas pb-20 lg:pb-28" data-id="element-324" data-mp="2fwj6gm20h8f1">
        <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-325" data-mp="2fvrbndg8nept">
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4" data-id="element-326" data-mp="2tw242kx751d3">
            {products.map(product => <ProductCard key={product.id} product={product} data-id="element-327" data-mp="2owxrdkb2cli0" />)}
          </div>

          <p className="mt-8 rounded-2xl bg-aqua-50 px-6 py-5 text-[15px] leading-relaxed text-ink-800 ring-1 ring-aqua-200" data-id="element-328" data-mp="2173dr0ix6swp">
            <span className="font-medium text-ink-950" data-id="element-329" data-mp="1w9uuewm1citv">
              Florida concierge membership.
            </span>{' '}
            Florida residents are now eligible for our concierge program &mdash;
            we handle acid changes, probe replacement and seasonal checks for
            you. Text &ldquo;CONCIERGE&rdquo; to get on the list.
          </p>
        </div>
      </section>

      <section className="border-t border-ink-950/8 bg-paper py-20 lg:py-24" data-id="element-330" data-mp="1dh0oes6e411s">
        <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-331" data-mp="3p4vxl0dle3d0">
          <div className="grid gap-10 sm:grid-cols-3" data-id="element-332" data-mp="3p3b31ara2kf5">
            {assurances.map(item => <div key={item.title} data-id="element-333" data-mp="3ty71asn3y40p">
                <item.icon className="h-5 w-5 text-aqua-600" aria-hidden="true" data-id="element-334" data-mp="3g5920v7jnrrv" />
                <h2 className="mt-4 font-display text-lg font-medium text-ink-950" data-id="element-335" data-mp="3k6ube6kvdnxb">
                  {item.title}
                </h2>
                <p className="mt-2.5 text-[15px] leading-relaxed text-ink-700" data-id="element-336" data-mp="boocjdgvc02o">
                  {item.body}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <FaqSection data-id="element-337" data-mp="7ow2sxfqnnvq" />
      <TextCta title="Ready to order? Send one text." lede="Tell us your pool size and city. We confirm the system, the price and the install window in the same thread." data-id="element-338" data-mp="7oe8458q5hpx" />
    </main>;
}